import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

export const BestsellersTopStylesSchema = z.array(z.object({
  lk_style_number: z.string().nullable(),
  product_name: z.string().nullable(),
  brand_name: z.string().nullable(),
  merch_portfolio: z.string().nullable(),
  brand_manager: z.string().nullable(),
  image: z.string().nullable(),
  merch_type: z.string().nullable(),
  category: z.string().nullable(),
  sub_category: z.string().nullable(),
  qty_sold: num(),
  gmv: num(),
  current_inv: numNull(),
  available_size_count: numNull().optional(),
  inward_size_count: numNull().optional(),
  size_percentage: numNull().optional(),
  avg_size_availability: numNull().optional(),
}));
export type BestsellersTopStyles = z.infer<typeof BestsellersTopStylesSchema>;

export const BestsellersSizeDemandSchema = z.array(z.object({
  lk_style_number: z.string().nullable(),
  size: z.string(),
  store_name: z.string(),
  channel: z.enum(['online', 'offline']),
  qty_sold: num(),
  revenue: num().optional(),
  product_name: z.string().nullable().optional(),
  brand_name: z.string().nullable().optional(),
  merch_portfolio: z.string().nullable().optional(),
  brand_manager: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  merch_type: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  sub_category: z.string().nullable().optional(),
}));
export type BestsellersSizeDemand = z.infer<typeof BestsellersSizeDemandSchema>;

export const AiTagWeeklySummarySchema = z.array(z.object({
  week: z.string(),
  ai_tag: z.string(),
  brand_name: z.string().nullable(),
  merch_portfolio: z.string().nullable(),
  unique_styles: num(),
  units_sold: num(),
  gmv: num(),
  prev_week_gmv: numNull(),
  four_week_avg_gmv: numNull(),
  wow_growth_pct: numNull(),
  mom_growth_pct: numNull(),
  momentum_status: z.string(),
  growth_band: z.string(),
}));
export type AiTagWeeklySummary = z.infer<typeof AiTagWeeklySummarySchema>;

export const CoyuSearchesSchema = z.array(z.object({
  search_term: z.string(),
  searches: num(),
  prev_searches: num(),
  trend_pct: numNull(),
}));
export type CoyuSearches = z.infer<typeof CoyuSearchesSchema>;

export const TagDetailItemsSchema = z.array(z.object({
  lk_style_number: z.string().nullable(),
  product_name: z.string().nullable(),
  brand_name: z.string().nullable(),
  image: z.string().nullable(),
  category: z.string().nullable(),
  sub_category: z.string().nullable(),
  qty_sold: num(),
  gmv: num(),
}));
export type TagDetailItems = z.infer<typeof TagDetailItemsSchema>;
